import React, { useEffect, useState } from 'react'
import App from "../../App";
import "../../assets/scss/order-list.scss";
import { getPaginatedList, PostCSV } from "../../services/baseServices";
import { getFormattedDate, getObjectToFormData } from '../../helper/utils';
import Pagination from "react-js-pagination";
import moment from "moment";
import { Button, Modal } from "react-bootstrap";
import Loader from 'react-loader';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { toast } from 'react-toastify';
import DateRangePicker from 'react-bootstrap-daterangepicker';


const schema = yup.object({
    file: yup.mixed().test("Required", "CSV is a required field", (value) => {
        return !value || value.length > 0;
    })
}).required();

const CustomerAcquisition = () => {
    var startDate = moment().subtract(7, 'days');
    var today = moment();
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        resolver: yupResolver(schema)
    });

    const [queryParams, setqueryParams] = useState({
        // pagination,
        // skip_pagination: false,
        per_page: 30,
        page: 1,
        acquisition_by: null,
        is_paid: null,
        start_date_time: startDate.format("YYYY-MM-DD"),
        end_date_time: today.format("YYYY-MM-DD"),
    })

    const [listData, setListData] = useState([])
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [submitting, setSubmitting] = useState(false)
    const [total, setTotal] = useState()
    const [ac, setAc] = useState('')
    const [isPaid, setIspaid] = useState('')
    useEffect(() => {
        getDataPagi()
    }, [queryParams])

    const getDataPagi = () => {
        setLoading(false)
        getPaginatedList('customer_acquisitions', queryParams)
            .then((res) => {
                if (res?.data?.success == true) {
                    setListData(res?.data?.data)
                    setLoading(true)
                    setTotal(res.headers['x-total'])
                }
                if (res?.data?.success == false) {
                    setListData([])
                    toast.error(res?.data?.message)
                    setLoading(true)
                }

            })
            .catch((error) => {
                console.log(error);
                setLoading(true)
            })

    }

    const handleOnFieldChange = (e) => {
        setAc(e.target.value)
        let qt = { ...queryParams }
        qt.acquisition_by = e.target.value ? e.target.value : null;
        qt.page = 1
        setqueryParams(qt)
    }
    const handlePaidOnChange = (e) => {
        setIspaid(e.target.value)
        let qt = { ...queryParams }
        qt.is_paid = e.target.value ? e.target.value : null;
        qt.page = 1
        setqueryParams(qt)
    }

    const handlePageChange = (pageNumber) => {
        let q = { ...queryParams }
        q.page = pageNumber
        setqueryParams(q)
    };

    const showModalhandler = () => {
        setShowModal(true)
    }
    const onSubmit = (data) => {
        setSubmitting(true)
        let params = { file: data.file[0] }
        params = getObjectToFormData(params)
        PostCSV('customer_acquisitions/update_payment_status', params)
            .then((res) => {
                if (res.success) {
                    setSubmitting(false)
                    setShowModal(false)
                    getDataPagi()
                    toast.success(res?.message)

                }
                else {
                    toast.error(res?.message)
                    setSubmitting(false)
                    setShowModal(false)
                }
            })
            .catch((error) => {
                console.log(error);
                setSubmitting(false)
            })
    }

    const handleOnApply = (e, picker) => {
        let qt = { ...queryParams }
        qt.start_date_time = getFormattedDate(picker.startDate, "YYYY-MM-DD")
        qt.end_date_time = getFormattedDate(picker.endDate, "YYYY-MM-DD")
        qt.page = 1
        setqueryParams(qt)
    }
    const handleClearOnSearch = (e) => {
        e.preventDefault()
        setqueryParams({
            per_page: 30,
            page: 1,
            acquisition_by: null,
            is_paid: null,
            start_date_time: startDate.format("YYYY-MM-DD"),
            end_date_time: today.format("YYYY-MM-DD"),
        })
        getDataPagi()
        setIspaid('')
        setAc('')
    }
    const options = [
        { label: "Ambassador", value: 'Ambassador' },
        { label: "Partner", value: 'Partner' },
        { label: "SR", value: 'SR' },
    ]
    const option2 = [
        { label: "Paid", value: true },
        { label: "Unpaid", value: false },
    ]
    return (
        <App layout="">
            <div className="main-content">
                <div className="page-header">
                    <h2 className="page-title">Customer Acquisition</h2>
                    <div className="ml-auto d-flex">
                        <button className='btn btn-md btn-outline-success'
                            onClick={showModalhandler}
                        >
                            Upload
                        </button>
                    </div>
                </div>

                <form className="form-inline mb-3">
                    <div className="form-group mr-3">
                        <label htmlFor="acquisition_by" className="sr-only">
                            Acquisition By
                        </label>
                        <select
                            id="acquisition_by"
                            name="acquisition_by"
                            value={ac}
                            className="form-control form-control-sm"
                            onChange={(e) => {
                                handleOnFieldChange(e);
                            }}
                        >
                            <option value=''>--Acquisition By--</option>
                            {
                                options.map((item, i) => {
                                    return <option key={i} value={item?.value}>
                                        {item?.label}
                                    </option>
                                })
                            }


                        </select>
                    </div>
                    <div className="form-group mr-3">
                        <label htmlFor="is_paid" className="sr-only">
                            Payment Status
                        </label>
                        <select
                            id="is_paid"
                            name="is_paid"
                            value={isPaid}
                            className="form-control form-control-sm"
                            onChange={(e) => {
                                handlePaidOnChange(e);
                            }}
                        >
                            <option value=''>--Payment Status--</option>
                            {
                                option2.map((item, i) => {
                                    return <option key={i} value={item?.value}>
                                        {item?.label}
                                    </option>
                                })
                            }


                        </select>
                    </div>
                    <div className="form-group mr-3">
                        <label htmlFor="status" className="sr-only">
                            Date Range
                        </label>
                        <DateRangePicker
                            initialSettings={{
                                startDate: queryParams?.start_date_time,
                                endDate: queryParams?.end_date_time,
                                maxSpan: { "months": 1 },
                                showDropdowns: true,
                                locale: { format: "YYYY-MM-DD" },
                                autoApply: true,
                                maxDate: queryParams?.end_date_time
                            }}
                            onApply={(e, picker) => handleOnApply(e, picker)}
                        >

                            <input type="text"
                                value={queryParams.start_date_time && queryParams.end_date_time ? `${getFormattedDate(queryParams.start_date_time, "YYYY-MM-DD")} - ${getFormattedDate(queryParams.end_date_time, "YYYY-MM-DD")}` : ''}
                                style={{ textAlign: 'left', minWidth: '150px' }}
                                placeholder={"Select date range"}
                                className="form-control form-control-sm" />
                        </DateRangePicker>
                    </div>
                    <Button
                        size="sm"
                        type={`submit`}
                        onClick={handleClearOnSearch}
                        variant="primary"
                    >
                        Clear
                    </Button>
                </form>
                <Loader loaded={loading}>
                    <div className="card-block">
                        <div className="block-body table-responsive">

                            <table className="order-table table table-striped">
                                <thead>
                                    <tr>
                                        <th style={{ width: "20px" }}>Acquisition ID</th>
                                        <th>Created At</th>
                                        <th>Information Status</th>
                                        <th>Is Paid</th>
                                        <th>Registered By Type</th>
                                        <th>Registered By</th>
                                        <th>User</th>
                                        <th>User Id</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        listData.length > 0 ? listData?.map((item, index) => {
                                            return <tr key={index} >
                                                <td>
                                                    {item?.id}
                                                </td>

                                                <td>
                                                    <div className="order-item">

                                                        {getFormattedDate(item?.created_at, "LT Do MMMM YYYY")}

                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="order-item">
                                                        {item?.information_status}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="order-item">
                                                        {item?.is_paid.toLocaleString()}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="order-item">
                                                        {item?.registered_by_type}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="order-item">
                                                        {item?.registered_by}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="order-item">
                                                        {item?.user}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="order-item">
                                                        {item?.user_id}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="order-item">
                                                        {item?.amount}
                                                    </div>
                                                </td>
                                            </tr>
                                        })
                                            :
                                            <tr>
                                                <td colSpan={15} className="text-center">
                                                    <h5>No Order Found</h5>
                                                </td>
                                            </tr>
                                    }

                                </tbody>
                            </table>
                        </div>
                        <div className="mt-3">
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                itemsCountPerPage={queryParams.per_page}
                                activePage={queryParams.page}
                                totalItemsCount={total}
                                pageRangeDisplayed={10}
                                onChange={(e) => handlePageChange(e)}
                            />
                        </div>
                    </div>
                </Loader>
            </div>

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Payment Status
                    </Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Body className="p-5">
                        <div className="row mb-2">
                            <div className="col-sm-3">
                                CSV File <span className="text-danger">*</span>
                            </div>
                            <div className="col-sm-9">
                                <input
                                    type="file"
                                    className="form-control-file"
                                    {...register('file')}
                                />
                                <p className='text-danger' style={{ lineHeight: '20px' }}>{errors.file?.message}</p>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Close
                        </Button>
                        <Button variant="primary" type='submit' disabled={submitting}>

                            {submitting ? "Submitting...." : "Submit"}
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </App>
    )
}

export default CustomerAcquisition